import React, { useState, useEffect } from 'react';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Typography, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import { getCategories, createCategory, updateCategory, deleteCategory } from '../services/api';

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [dialog, setDialog] = useState({ open: false, category: null });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, category: null });
  const [form, setForm] = useState({ name: '', description: '', color: '#0350AC' });

  useEffect(() => { loadCategories(); }, []);

  const loadCategories = async () => {
    try {
      const { data } = await getCategories();
      setCategories(data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleOpen = (category = null) => {
    if (category) {
      setForm({ name: category.name, description: category.description || '', color: category.color || '#0350AC' });
    } else {
      setForm({ name: '', description: '', color: '#0350AC' });
    }
    setDialog({ open: true, category });
  };

  const handleSave = async () => {
    try {
      if (dialog.category) {
        await updateCategory(dialog.category._id, form);
      } else {
        await createCategory(form);
      }
      setDialog({ open: false, category: null });
      loadCategories();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteCategory(deleteDialog.category._id);
      setDeleteDialog({ open: false, category: null });
      loadCategories();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">Categories</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => handleOpen()}>
          Nouvelle categorie
        </Button>
      </Box>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Description</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((cat) => (
                <TableRow key={cat._id} hover>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: cat.color || '#0350AC' }} />
                      <Typography fontWeight="medium">{cat.name}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{cat.slug}</TableCell>
                  <TableCell>{cat.description}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => handleOpen(cat)}><Edit /></IconButton>
                    <IconButton size="small" color="error" onClick={() => setDeleteDialog({ open: true, category: cat })}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog open={dialog.open} onClose={() => setDialog({ open: false, category: null })} maxWidth="sm" fullWidth>
        <DialogTitle>{dialog.category ? 'Modifier' : 'Nouvelle categorie'}</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} margin="normal" />
          <TextField fullWidth label="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} margin="normal" multiline rows={2} />
          <TextField fullWidth label="Couleur" type="color" value={form.color} onChange={(e) => setForm({ ...form, color: e.target.value })} margin="normal" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog({ open: false, category: null })}>Annuler</Button>
          <Button variant="contained" onClick={handleSave}>Enregistrer</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, category: null })}>
        <DialogTitle>Confirmer la suppression</DialogTitle>
        <DialogContent>Supprimer "{deleteDialog.category?.name}" ?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, category: null })}>Annuler</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CategoriesPage;
